var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancySalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28625 3.82178H3.824C3.824 3.82178 0 7.09854 0 10.9225C0 13.1066 1.64444 14.1993 2.73112 14.1993H10.3789C11.4701 14.1993 13.11 13.1065 13.11 10.9225C13.11 7.09854 9.28598 3.82178 9.28598 3.82178H9.28625ZM7.10074 11.4129V12.2875H6.00949L6.00938 11.4159C5.2051 11.2663 4.69988 10.7701 4.66403 10.0495H5.61033C5.65663 10.4277 6.03787 10.6714 6.58948 10.6714C7.09772 10.6714 7.45799 10.4248 7.45799 10.0735C7.45799 9.77457 7.22483 9.60407 6.6508 9.47561L6.04235 9.34558C5.19021 9.16769 4.77164 8.72368 4.77164 8.01064C4.77164 7.2976 5.24704 6.7833 6.00346 6.61438V5.73378H7.09471V6.61574C7.83319 6.78018 8.32506 7.28393 8.34893 7.96109L7.43557 7.9612C7.38927 7.59196 7.04538 7.34535 6.57301 7.34535C6.10065 7.34535 5.75976 7.57257 5.75976 7.92836C5.75976 8.21691 5.9825 8.37686 6.5311 8.49939L7.09471 8.61899C8.03497 8.81628 8.44006 9.2169 8.44006 9.94798C8.44017 10.7297 7.93788 11.253 7.10074 11.413L7.10074 11.4129Z",
    fill: "#E7B92A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28623 0.543369H7.77641C7.46451 0.197487 7.02071 0 6.55503 0C6.08934 0 5.64554 0.197497 5.33364 0.543369H3.82382C3.64322 0.544099 3.47471 0.633983 3.37335 0.783412C3.27199 0.93284 3.25093 1.12273 3.31704 1.29082L3.82381 2.72742H9.28606L9.79283 1.29082C9.85894 1.12273 9.83788 0.932848 9.73652 0.783412C9.63516 0.633975 9.46666 0.5441 9.28605 0.543369H9.28623Z",
    fill: "#E7B92A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancySalary);
export default __webpack_public_path__ + "static/media/vacancySalary.fde20d458fbb5eaad6df053262e13239.svg";
export { ForwardRef as ReactComponent };